import { getcompany, getDicsType, getDicType, getStationByCompanyId, get_simple_organization } from "@/api/common.js";
import { get_simple_user_listBycompanyId } from "@/api/GHnumber/contract";
import { getDisClostDetail } from "@/api/internetSales/projectClarifi.js";
import { graphic_list } from "@/api/smart/schedul/b.js";
import { queryPhaseHistory } from "@/api/internetSales/performanceRecord.js";
import { queryControlMession } from "@/api/internetSales/supplyManagement.js";
import { queryProcesses } from "@/api/basicConfig/proflow.js";
import {
  updatePhaseAndControl,
  // updateBudget,
  cancelPlanByIds,
  check_order,
  controlqueryPhase,
  // controlupdatePhase,
  // controlsavePhase,
  getContractVoList,
  get_assess,
  get_graphic_manager,
  operation_detail,
  planRemark,
  plan_detail,
  plan_list,
  plan_table_detail,
  queryOneResord,
  queryPage,
  savePlan,
  updateDisCole,
  queryPlanProductCost,
  concleCompleStatus,
  getGraException,
  saveSurplus,
  DownloadURL,
  queryExcessAllowance
} from "@/api/smart/schedul/c.js";
import { useruser_list } from "@/api/smart/schedul/f.js";
import mixin from "@/mixins/ICPSmixin.js";
import { getUserInfo } from "@/utils/auth.js";
import { _debounce } from "@/utils/utils.js";
import moment from "moment";

export default {
  mixins: [mixin],
  data() {
    return {
      phaseUpdateObj: null,
      phaseTitle: "",
      phaseStartDate: "", //阶段开始日期
      historyPhase: [], //历史供应状态
      phaseChose: false,
      phaseChoseAdd: false,
      phaseChoseText: "",
      phaseChoseDate: "",
      phaseChoseDate2: "",
      supplyPhaseList: [],
      supplyPhaseName: "",
      supplyPhaseId: "",
      engineeringPhaseList: [],
      engineeringPhaseName: "",
      engineeringPhaseId: "",
      updateEngineeringId: "",
      detailData: {},
      showCardNav2: false,
      UserInfo: "",
      companylist: [], //公司
      sitelist: [], //站点
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: DownloadURL,
      loading: false,
      currenindex: 1,
      contractTypelist: [
        { value: "供应中", id: 1 },
        { value: "完工未办", id: 2 },
        { value: "完工已办", id: 3 },
      ],
      /*表格数据*/
      table: [
        { label: "合同号", width: "", prop: "contractNo", status: true },
        { label: "工程名称", width: "", prop: "engineeringName", status: true },
        { label: "客户名称", width: "", prop: "customerName", status: true },
        { label: "交底时间", width: "", prop: "disclosureTime", status: true },
        { label: "负责人", width: "", prop: "chargePerson", status: true },
        { label: "预估用砼量", width: "", prop: "expectedAmount", status: true },
        { label: "累计浇筑量（方）", width: "", prop: "totalPoureCount", status: true },
        { label: "累计订单数量", width: "", prop: "totalOrderCount", status: true },
        { label: "待审核", width: "", prop: "notReviewCount", status: true },
        { label: "结算方式", width: "", prop: "paymentMethod", status: true },
        { label: "富余量申请", width: "", prop: "paymentMethod", status: true },
        { label: "用料计划", width: "", prop: "", status: true },
        { label: "工程负责", width: "", prop: "", status: false },
        { label: "工程供应状态", width: "150", prop: "", status: true },
        // {
        //   label: "工程阶段",
        //   width: "150",
        //   prop: "",
        //   status: true,
        // },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      pouringHigh: {
        required: true,
        message: "请输入泵送高度",
        trigger: "change",
      },
      rules: {
        structuralParts: [
          {
            required: true,
            message: "请输入浇筑部位",
            trigger: "change",
          },
        ],
        pouringTime: [
          {
            required: true,
            message: "请选择浇筑时间",
            trigger: "change",
          },
        ],
        graphicNum: [
          {
            required: true,
            message: "请输入图算量",
            trigger: "blur",
          },
        ],
        pouringHigh: [],
        person: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "change",
          },
        ],
        phoneNum: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "change",
          },
          { min: 11, max: 11, message: "手机号格式错误", trigger: "change" },
        ],
      },
      /*添加表单数据*/
      rules2: {
        person: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "change",
          },
        ],
        phoneNum: [
          { required: true, message: "请输入联系电话", trigger: "change" },
          { min: 11, max: 11, message: "手机号格式错误", trigger: "change" },
        ],
        pouringTime: [
          {
            required: true,
            message: "请选择浇筑时间",
            trigger: "change",
          },
        ],
        pouringHigh: [
          {
            required: true,
            message: "请输入泵送高度",
            trigger: "change",
          },
        ],
        noteName: [
          {
            required: true,
            message: "请输入票单名称",
            trigger: "change",
          },
        ],
        graphicNum: [
          {
            required: true,
            message: "请输入图算量",
            trigger: "change",
          },
        ],
      },
      rules3: {
        budgetPersonId: [{ required: true, message: "请选择预算员", trigger: "change" }],
        buseftPlaceTypeId: [{ required: true, message: "请选择预算员处别", trigger: "change" }],
        sallerId: [{ required: true, message: "请选择销售员", trigger: "change" }],
        placeTypeId: [{ required: true, message: "请选择销售员处别", trigger: "change" }],
      },
      rules2_2: {
        pointId: [
          {
            required: true,
            message: "请选择供应站点名称",
            trigger: "change",
          },
        ],
        settleId: [
          {
            required: true,
            message: "请选择结算方式",
            trigger: "change",
          },
        ],
        lossNumId: [
          {
            required: true,
            message: "请选择损耗量",
            trigger: "change",
          },
        ],
        foremanId: [
          {
            required: true,
            message: "请输入前场工长",
            trigger: "change",
          },
        ],
        graphicNum: [
          {
            required: true,
            message: "请输入图算量",
            trigger: "change",
          },
        ],
      },
      formData: {
        strengthGradeId: "", //强度等级
        performanceGradeIdList: [],
        meterialRequirementsIdList: [],
        specialRequirementsIdList: [],
        otherRequirementsIdList: [],
        admixtureRequirementsIdList: [],
        pouringMethodIdList: [],
        pouringTime: "", //浇筑时间
        slump: "",
        slumpId: "",
        graphicNum: "",
      },
      engineeringRow: {}, //工程对象
      engineeringName: "",
      engineeringId: "", //工程id
      id: "", //计划id
      ToViewType: false,
      toViewList: [],
      tableInfo: {},
      addDialog: false,
      addDialog2: false,
      chooseType: false,
      isSurplus: false, //是否可以选择富余量
      engineeringManagement: [],
      strengthGradeList: [], //强度list
      performanceGradeList: [], //性能等级list
      meterialRequirementsList: [], //材料要求list
      specialRequirementsList: [], //特殊要求list
      otherRequirementsList: [], //其他要求list
      admixtureRequirementsList: [], //外加剂要求list
      pouringMethodList: [], //浇筑方式list
      structuralPartsList: [], //浇筑部位
      goodPriceList: [],
      formData2: {
        performanceGradeIdList: [],
        meterialRequirementsIdList: [],
        specialRequirementsIdList: [],
        otherRequirementsIdList: [],
        admixtureRequirementsIdList: [],
        pouringMethodIdList: [],
      },
      formData2_2: { pointId: "", settleId: "", lossNumId: "", foremanId: "" },
      assess: {},
      ListArr: [],
      toViewList2: [],
      searchText: "",
      foremanIdList: [],
      ToViewFun3Name: "",
      radio: {},
      marginNumberList: [],
      budgetPersonIdList: [],
      yuSuanTypeList: [],
      sallerIdList: [],
      placeTypeList: [],
      budgetPersonIdList2: [],
      remarkList: [],
      bussinessVisible: false,
      buspointArr: [],
      slumpArr: [],
      servicePoint: "",
      buspointids: [],
      query: {},
      ids: [],
      isReadOnly: false,
      personEdit: false,
      tableParam: {
        engineeringName: "",
        contractNo: "",
        budgetPersonId: "",
        surplusApplay: "",
      },
      personForm: {
        budgetPersonId: "",
        budgetPerson: "",
        buseftPlaceTypeId: "",
        buseftPlaceType: "",
        sallerId: "",
        saller: "",
        placeTypeId: "",
        placeType: "",
      },
      phaseForm: {
        engineeringId: "",
        id: "",
        field1: "",
        type: "1", //  1: 工程供应状态，2：工程阶段
      },
      supperHighLayerList: [
        { value: 1, label: "是" },
        { value: 0, label: "否" },
      ],
      buttonType: false,
      ProductCostDig: false,
      surplusDialog: false,
      surplusJudgeList: [],
      surplusList: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
          name: "小二",
          status: 1,
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
          name: "小三",
          status: 1,
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
          name: "小四",
          status: 2,
        },
      ],
      surplusDateDialog: false,
      surplusDate: [],
      surplusFormData: {
        startTime: "",
        endTime: "",
        id: "",
        engineeringId: "",
        engineeringName: "",
      },
      priceTableData: "",
      planProductCost: "",
      addOrExamine: 1, //1添加时的价格弹窗,2审批时的价格弹窗
    };
  },
  watch: {
    tableData: {
      async handler() {
        // for (let i = 0; i < this.tableData.length; i++) {
        //   await controlqueryPhase({
        //     engineeringId: this.tableData[i].engineeringId,
        //     type: 1,
        //   }).then((res) => {
        //     res.data.push(
        //       { id: "1", supplyPhase: "无" },
        //       { id: "2", supplyPhase: "供应完成" }
        //     );
        //     this.tableData[i].phaseIdList = res.data;
        //     this.tableData[i].phaseId0 = this.tableData[i].phaseId;
        //   });
        // }
        // for (let i = 0; i < this.tableData.length; i++) {
        //   await controlqueryPhase({
        //     engineeringId: this.tableData[i].engineeringId,
        //     type: 2,
        //   }).then((res) => {
        //     res.data.push({ id: "1", supplyPhase: "无" });
        //     this.tableData[i].engineeringPhaseList = res.data;
        //     this.tableData[i].engineeringPhaseId0 =
        //       this.tableData[i].engineeringPhaseId; //工程阶段id字段，待后端添加
        //   });
        // }
        // console.log(this.tableData, "组装后的表格数据");
        this.$forceUpdate();
      },
    },
  },
  async created() {
    this.UserInfo = await getUserInfo();
    if (this.UserInfo.adminStatus == 1) {
      /**通过typeId为公司类型id查询所有公司 */
      getcompany({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        this.companylist = res.data;
      });
    }
    this.tableParam = {
      ...this.tableParam,
      name: "",
      phaseName: 1,
    };
    /**角色：预算员id不能改 */
    await useruser_list({ roleId: "48d84b503be7484ca1b5c2eade1ff004" }).then(res => {
      this.budgetPersonIdList = res.data;
      let id = this.budgetPersonIdList.findIndex(v => v.userId == this.UserInfo.userId);
      if (id != -1) {
        this.tableParam.budgetPersonId = this.budgetPersonIdList[id].userId;
      }
      this.gettableData();
    });
    getDicsType({ codes: "placeDon, YSchubie" }).then(res => {
      if (res.code === 1001) {
        this.placeTypeList = res.data.placeDon.items;
        this.yuSuanTypeList = res.data.YSchubie.items;
      }
    });
    // getDicType({
    //   code: "marginNumber",
    // }).then(res => {
    //   this.marginNumberList = res.data.items;
    // });
    // getDicType({
    //   code: "market",
    // }).then(res => {
    //   this.buspointArr = res.data.items;
    // });
    getDicType({
      code: "slump",
    }).then(res => {
      this.slumpArr = res.data.items;
    });
  },
  methods: {
    downLoad() {
      this.$Download(this.DownloadURL, this.tableParam);
    },
    concleCompleStatus(item) {
      this.$confirm("请确认是否作废", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          concleCompleStatus(item).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "作废成功",
                type: "success",
              });
              this.openUpdatePhase(this.low, 1);
              this.phaseChose = false;
              this.gettableData();
            }
          });
        })
        .catch(() => {});
    },
    changePhaseChose(name) {
      this.phaseChoseAdd = true;
      this.phaseChoseText = "修改";
      this.timeLimt(name);
      this.phaseForm.id = this.engineeringPhaseList.find(item => item.supplyPhase == name).id;
    },
    timeLimt(name) {
      this.phaseChoseDate = "";
      this.phaseChoseDate2 = "";
      this.engineeringPhaseList.forEach((item, index) => {
        if (item.supplyPhase == name) {
          if (index != 0 && index != this.engineeringPhaseList.length - 1) {
            this.phaseChoseDate = this.engineeringPhaseList[index - 1].dateSharding;
            this.phaseChoseDate2 = this.engineeringPhaseList[index + 1].dateSharding;
          }
          if (index == 0) {
            this.phaseChoseDate2 = this.engineeringPhaseList[index + 1].dateSharding;
          }
          if (index == this.engineeringPhaseList.length - 1) {
            this.phaseChoseDate = this.engineeringPhaseList[index - 1].dateSharding;
          }
          console.log(this.phaseChoseDate);
          console.log(this.phaseChoseDate2);
        }
      });
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        if (rowIndex < this.planProductCost.productCosts.length + this.planProductCost.pumpCosts.length) {
          if (rowIndex === 0) {
            return {
              rowspan: this.planProductCost.productCosts.length,
              colspan: 1,
            };
          } else if (rowIndex == this.planProductCost.productCosts.length) {
            return {
              rowspan: this.planProductCost.pumpCosts.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
    addProductCost() {
      this.$refs.reffromData.validate(valid => {
        if (valid) {
          //接口判断 图算超量异常限制
          getGraException({ engineeringId: this.engineeringId, stationId: this.formData.pointId }).then(res => {
            if (res.code == 1001) {
              if (res.data.isHaveException) {
                if (res.data.isLimit) {
                  this.$message.warning("当前工程下有图算超量异常计划！");
                  return;
                } else {
                  this.$confirm("当前工程下有图算超量异常计划,请确定是否提交?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    cancelButtonClass: "bottom_all_two",
                    confirmButtonClass: "bottom_all",
                    type: "warning",
                  }).then(() => {
                    this.saveProductCost();
                  });
                }
              } else {
                this.saveProductCost();
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    saveProductCost() {
      // 保存
      this.formData.engineeringName = this.engineeringName;
      this.formData.engineeringId = this.engineeringId;
      this.formData.strengthGrade = this.$fromatTable(this.strengthGradeList, this.formData.strengthGradeId, "id", "name");
      //性能等级-开始数据重装
      if (this.formData.performanceGradeIdList.length > 0) {
        let arr = [];
        this.formData.performanceGradeIdList.forEach(v => {
          this.performanceGradeList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData.performanceGradeId = arr;
        this.formData.performanceGradeId = JSON.stringify(this.formData.performanceGradeId);
        this.formData.performanceGrade = this.formData.performanceGradeId;
      }
      //材料要求-开始数据重装
      if (this.formData.meterialRequirementsIdList.length > 0) {
        let arr = [];
        this.formData.meterialRequirementsIdList.forEach(v => {
          this.meterialRequirementsList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData.meterialRequirementsId = arr;
        this.formData.meterialRequirementsId = JSON.stringify(this.formData.meterialRequirementsId);
        this.formData.meterialRequirements = this.formData.meterialRequirementsId;
      }
      //特殊要求-开始数据重装
      if (this.formData.specialRequirementsIdList.length > 0) {
        let arr = [];
        this.formData.specialRequirementsIdList.forEach(v => {
          this.specialRequirementsList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData.specialRequirementsId = arr;
        this.formData.specialRequirementsId = JSON.stringify(this.formData.specialRequirementsId);
        this.formData.specialRequirements = this.formData.specialRequirementsId;
      }
      //其他要求-开始数据重装
      if (this.formData.otherRequirementsIdList.length > 0) {
        let arr = [];
        this.formData.otherRequirementsIdList.forEach(v => {
          this.otherRequirementsList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData.otherRequirementsId = arr;
        this.formData.otherRequirementsId = JSON.stringify(this.formData.otherRequirementsId);
        this.formData.otherRequirements = this.formData.otherRequirementsId;
      }
      //外加剂要求-开始数据重装
      if (this.formData.admixtureRequirementsIdList.length > 0) {
        let arr = [];
        this.formData.admixtureRequirementsIdList.forEach(v => {
          this.admixtureRequirementsList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData.admixtureRequirements = arr;
        this.formData.admixtureRequirements = JSON.stringify(this.formData.admixtureRequirements);
      }
      //浇筑方式-开始数据重装
      if (this.formData.pouringMethodIdList.length > 0) {
        let arr = [];
        this.formData.pouringMethodIdList.forEach(v => {
          this.pouringMethodList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
                type: v2.type,
              });
            }
          });
        });
        this.formData.pouringMethod = arr;
      }
      this.formData.pouringMethod = JSON.stringify(this.formData.pouringMethod);
      this.formData.approvalStatus = 1;
      this.structuralPartsFun();
      this.formData.companyId = this.engineeringRow.companyId;
      this.formData.companyName = this.engineeringRow.companyName;
      this.formData.engineeringId = this.detailData.engineeringId;
      let params = {
        strengthGradeId: this.formData.strengthGradeId,
        // servicePoint: this.formData.servicePoint,
        engineeringId: this.formData.engineeringId,
        strengthGrade: this.$fromatTable(this.strengthGradeList, this.formData.strengthGradeId, "id", "name"),
        performanceGradeId: this.formData.performanceGradeId,
        performanceGrade: this.formData.performanceGradeId,
        meterialRequirementsId: this.formData.meterialRequirementsId,
        meterialRequirements: this.formData.meterialRequirementsId,
        specialRequirementsId: this.formData.specialRequirementsId,
        specialRequirements: this.formData.specialRequirementsId,
        otherRequirementsId: this.formData.otherRequirementsId,
        otherRequirements: this.formData.otherRequirementsId,
        admixtureRequirements: this.formData.admixtureRequirements,
        pouringMethod: this.formData.pouringMethod,
        supperHighLayer: this.formData.supperHighLayer,
        pouringHigh: this.formData.pouringHigh,
        stationId: this.formData.pointId //新增站点
      };
      queryPlanProductCost(params).then(res => {
        if (res.code == 1001) {
          this.planProductCost = res.data;
          this.priceTableData = [...res.data.productCosts, ...res.data.pumpCosts];
          let smallQuantityObj = {
            dataType: "小方量",
            name: res.data.smallQuantity,
          };
          let sprcialProvisionsObj = {
            dataType: "特殊条款",
            name: res.data.sprcialProvisions,
          };
          this.priceTableData.push(res.data.superHighs);
          this.priceTableData.push(smallQuantityObj);
          this.priceTableData.push(sprcialProvisionsObj);
          this.addOrExamine = 1;
          this.ProductCostDig = true;
        }
      });
    },
    addProductCost2() {
      this.$refs.reffromData2.validate(valid => {
        if (valid) {
          this.$refs.reffromData2_2.validate(valid => {
            if (valid) {
              //接口判断 图算超量异常限制
              getGraException({ engineeringId: this.engineeringId, stationId: this.formData2_2.pointId }).then(res => {
                if (res.code == 1001) {
                  if (res.data.isHaveException) {
                    if (res.data.isLimit) {
                      this.$message.warning("当前工程下有图算超量异常计划！");
                      return;
                    } else {
                      this.$confirm("当前工程下有图算超量异常计划,请确定是否提交?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        cancelButtonClass: "bottom_all_two",
                        confirmButtonClass: "bottom_all",
                        type: "warning",
                      }).then(() => {
                        this.saveProductCost2();
                      });
                    }
                  } else {
                    this.saveProductCost2();
                  }
                }
              });
            } else {
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    saveProductCost2() {
      //性能等级-开始数据重装
      if (this.formData2.performanceGradeIdList.length > 0) {
        let arr = [];
        this.formData2.performanceGradeIdList.forEach(v => {
          this.performanceGradeList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData2.performanceGradeId = arr;
        this.formData2.performanceGradeId = JSON.stringify(this.formData2.performanceGradeId);
        this.formData2.performanceGrade = this.formData2.performanceGradeId;
      }
      //材料要求-开始数据重装
      if (this.formData2.meterialRequirementsIdList.length > 0) {
        let arr = [];
        this.formData2.meterialRequirementsIdList.forEach(v => {
          this.meterialRequirementsList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData2.meterialRequirementsId = arr;
        this.formData2.meterialRequirementsId = JSON.stringify(this.formData2.meterialRequirementsId);
        this.formData2.meterialRequirements = this.formData2.meterialRequirementsId;
      }
      //特殊要求-开始数据重装
      if (this.formData2.specialRequirementsIdList.length > 0) {
        let arr = [];
        this.formData2.specialRequirementsIdList.forEach(v => {
          this.specialRequirementsList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData2.specialRequirementsId = arr;
        this.formData2.specialRequirementsId = JSON.stringify(this.formData2.specialRequirementsId);
        this.formData2.specialRequirements = this.formData2.specialRequirementsId;
      }
      //其他要求-开始数据重装
      if (this.formData2.otherRequirementsIdList.length > 0) {
        let arr = [];
        this.formData2.otherRequirementsIdList.forEach(v => {
          this.otherRequirementsList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData2.otherRequirementsId = arr;
        this.formData2.otherRequirementsId = JSON.stringify(this.formData2.otherRequirementsId);
        this.formData2.otherRequirements = this.formData2.otherRequirementsId;
      }
      //外加剂要求-开始数据重装
      if (this.formData2.admixtureRequirementsIdList.length > 0) {
        let arr = [];
        this.formData2.admixtureRequirementsIdList.forEach(v => {
          this.admixtureRequirementsList.forEach(v2 => {
            if (v == v2.id) {
              arr.push({
                id: v,
                name: v2.name,
              });
            }
          });
        });
        this.formData2.admixtureRequirements = arr;
        this.formData2.admixtureRequirements = JSON.stringify(this.formData2.admixtureRequirements);
      }
      //浇筑方式-开始数据重装
      if (this.formData2.pouringMethodIdList.length > 0) {
        console.log(this.formData2.pouringMethodIdList);
        let arr = [];
        this.formData2.pouringMethodIdList.forEach(v => {
          this.pouringMethodList.forEach(v2 => {
            if (v == v2.id || v == v2.name) {
              arr.push({
                id: v2.id,
                name: v2.name,
                type: v2.type,
              });
            }
          });
        });
        this.formData2.pouringMethod = arr;
        this.formData2.pouringMethod = JSON.stringify(this.formData2.pouringMethod);
      }
      this.formData2.customerCheckStatus = 0;

      let params = {
        strengthGradeId: this.formData2.strengthGradeId,
        // servicePoint: this.formData2.servicePoint,
        engineeringId: this.formData2.engineeringId,
        strengthGrade: this.$fromatTable(this.strengthGradeList, this.formData2.strengthGradeId, "id", "name"),
        performanceGradeId: this.formData2.performanceGradeId,
        performanceGrade: this.formData2.performanceGradeId,
        meterialRequirementsId: this.formData2.meterialRequirementsId,
        meterialRequirements: this.formData2.meterialRequirementsId,
        specialRequirementsId: this.formData2.specialRequirementsId,
        specialRequirements: this.formData2.specialRequirementsId,
        otherRequirementsId: this.formData2.otherRequirementsId,
        otherRequirements: this.formData2.otherRequirementsId,
        admixtureRequirements: this.formData2.admixtureRequirements,
        pouringMethod: this.formData2.pouringMethod,
        supperHighLayer: this.formData2.supperHighLayer,
        pouringHigh: this.formData2.pouringHigh,
        stationId: this.formData2.pointId //新增站点
      };
      queryPlanProductCost(params).then(res => {
        if (res.code == 1001) {
          this.planProductCost = res.data;
          this.priceTableData = [...res.data.productCosts, ...res.data.pumpCosts];
          let smallQuantityObj = {
            dataType: "小方量",
            name: res.data.smallQuantity,
          };
          let sprcialProvisionsObj = {
            dataType: "特殊条款",
            name: res.data.sprcialProvisions,
          };
          this.priceTableData.push(res.data.superHighs);
          this.priceTableData.push(smallQuantityObj);
          this.priceTableData.push(sprcialProvisionsObj);
          this.addOrExamine = 2;
          this.ProductCostDig = true;
        }
      });
    },
    //跳转对接订单
    dockPlan() {
      this.$router.push("dockPlan");
    },
    /**
     * @Description: 工程负责人调整
     * @param {*}
     * 

     * @Author: wangwangwang
     */

    typeChange(val) {
      if (val == 0) {
        this.$set(this.rules.pouringHigh, 0, "");
      } else {
        //开启校验
        this.$set(this.rules.pouringHigh, 0, this.pouringHigh);
      }
    },
    personHandleClick() {
      this.$refs.personForm.validate(valid => {
        if (valid) {
          updateDisCole({
            ...this.personForm,
            engineeringId: this.engineeringId,
          }).then(res => {
            if (res.code === 1001) {
              this.$message.success("调整成功");
              this.personEdit = false;
            }
          });
        }
      });
    },
    updatePhase() {
      let that = this;
      let item = this.engineeringPhaseList.find(item => item.id === this.phaseForm.id);
      if (!item) {
        this.message.$warning("请选择" + this.phaseTitle);
        return;
      }
      let params = { ...this.phaseForm };
      if (this.phaseForm.type === 1) {
        // 工程供应状态
        params.supplyPhase = item.supplyPhase;
        params.engineeringPhase = undefined;
        params.field2 = item.field2;
      } else {
        params.supplyPhase = undefined;
        params.engineeringPhase = item.supplyPhase;
      }
      console.log(item);

      updatePhaseAndControl(params).then(res => {
        if (res.code == 1001) {
          that.phaseChoseAdd = false;
          that.openUpdatePhase(that.low, 1);
          that.gettableData();
        }
      });
    },
    chosePhase(typeStr, e) {
      if (typeStr === "工程阶段") {
        // this.engineeringPhaseId = e
        // this.phaseStartDate =this.engineeringPhaseList.find(
        //   (item) => item.id == e
        // ).monthSharding
        this.phaseUpdateObj = {
          engineeringId: this.engineeringId,
          id: this.engineeringPhaseId,
          field1: this.phaseStartDate,
          engineeringPhase: this.engineeringPhaseList.find(item => item.id == e).supplyPhase,
        };
      } else {
        this.phaseUpdateObj = {
          engineeringId: this.engineeringId,
          id: this.supplyPhaseId,
          field1: this.phaseStartDate,
          supplyPhase: this.supplyPhaseList.find(item => item.id == e).supplyPhase,
        };
      }
      console.log(this.phaseUpdateObj, typeStr, e);
    },
    // 打开弹窗
    openUpdatePhase(row, type) {
      // 获取对应阶段列表
      console.log(row);
      this.low = row;
      this.phaseForm = {
        engineeringId: row.engineeringId,
        id: "",
        field1: "",
        type: type, //  1: 工程供应状态，2：工程阶段,
        supplyPhase: row.supplyPhase,
        engineeringPhase: row.engineeringPhase,
      };
      queryPhaseHistory({
        engineeringId: row.engineeringId,
      }).then(res => {
        this.historyPhase = res.data;
      });
      if (type === 2) {
        this.phaseTitle = "工程阶段";
        this.phaseForm.id = row.engineeringPhaseId;
        controlqueryPhase({
          engineeringId: row.engineeringId,
          type: 2,
        }).then(res => {
          res.data.push({ id: "1", supplyPhase: "无" });
          this.engineeringPhaseList = res.data;
          this.setDefaultPhase();
          this.phaseChose = true;
        });
        console.log(this.phaseUpdateObj, this.engineeringId);
      } else {
        this.phaseTitle = "供应阶段";
        this.phaseForm.id = row.phaseId;
        // this.phaseStartDate
        controlqueryPhase({
          engineeringId: row.engineeringId,
          // type: 1,
        }).then(res => {
          res.data.push(
            { id: "1", supplyPhase: "无" }
            // { id: "2", supplyPhase: "供应完成" }
          );
          this.engineeringPhaseList = res.data;
          var compare = function (obj1, obj2) {
            var val1 = Date.parse(obj1.dateSharding);
            var val2 = Date.parse(obj2.dateSharding);
            if (val1 > val2) {
              return -1;
            } else if (val1 < val2) {
              return 1;
            } else {
              return 0;
            }
          };
          this.engineeringPhaseList.sort(compare);
          console.log(this.engineeringPhaseList);
          this.setDefaultPhase();
          this.phaseChose = true;
        });
      }
    },
    setDefaultPhase() {
      if (this.phaseForm.id) {
        let item = this.engineeringPhaseList.find(item => item.id === this.phaseForm.id);
        console.log(item);
        if (item) {
          this.phaseForm.field1 = item.dateSharding;
        }
      }
    },
    choose(num) {
      this.currenindex = num;
      this.tableParam.phaseName = this.currenindex;
      this.tableParam.page = 1;
      this.gettableData();
    },
    handleSelectionChange(val) {
      this.ids = val;
    },
    cancelPlanByIdsFun() {
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      this.$confirm("此操作将取消订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let arr = this.ids.map(res => res.id);
        cancelPlanByIds(arr).then(res => {
          if (res.code == 1001) {
            this.ids = [];
            this.ToViewFun();
            this.$message({
              type: "success",
              message: "订单取消成功!",
            });
          }
        });
        plan_list({
          engineeringId: this.engineeringId,
          ...this.query,
        }).then(res => {
          this.toViewList = res.data;
        });
      });
    },
    /**
     * @Description: 选择管控业务点
     * @Param:
     * @Author: wangwangwang
     */
    // choiseBussinessPoint() {
    //   this.bussinessVisible = true;
    // },
    // handlePoint() {
    //   const newData = this.buspointArr.filter(item => this.buspointids.some(items => item.id === items));
    //   this.servicePoint = newData.map(item => item.itemName).join(",");
    //   this.formData2.servicePoint = JSON.stringify(newData.map(item => ({ id: item.id, name: item.itemName, type: 1 })));
    //   this.formData.servicePoint = JSON.stringify(newData.map(item => ({ id: item.id, name: item.itemName, type: 1 })));
    //   this.bussinessVisible = false;
    // },
    // 新逻辑
    choiseBussinessPoint(type) {
      const currentPointId = this.addDialog ? this.formData.pointId : this.formData2_2.pointId;
      if (!currentPointId && !type) {
        this.$message.warning("请选择主供应站点后再进行操作");
        return;
      }
      if (!type) {
        this.bussinessVisible = true;
      }
      if (currentPointId) {
        // 统一使用新接口替换老字典与老联动
        queryProcesses({ stationId: currentPointId }).then(res => {
          if (res.code === 1001) {
            const allItems = res.data.servicePoint ? JSON.parse(res.data.servicePoint) : [];
            this.buspointArr = allItems.map(item => ({
              id: item.id,
              itemName: item.name || item.itemName
            }));
            const copyData = allItems.filter(item => item.type * 1 === 1);
            this.buspointids = copyData.map(item => item.id);
            this.servicePoint = copyData.map(item => item.name || item.itemName).join("、");
            const servicePointJson = JSON.stringify(copyData.map(item => ({ id: item.id, name: item.name || item.itemName, type: 1 })));
            if (this.addDialog) {
              this.formData.servicePoint = servicePointJson;
            } else {
              this.formData2.servicePoint = servicePointJson;
            }
          }
        });
      }
    },
    handlePoint() {
      // 从动态获取的 buspointArr 中过滤出用户选中的项
      const newData = this.buspointArr.filter(item => this.buspointids.some(items => item.id === items));
      this.servicePoint = newData.map(item => item.itemName).join(",");
      const servicePointJson = JSON.stringify(newData.map(item => ({ id: item.id, name: item.itemName, type: 1 })));
      
      if (this.addDialog) {
        this.formData.servicePoint = servicePointJson;
      } else {
        this.formData2.servicePoint = servicePointJson;
      }
      this.bussinessVisible = false;
    },

    /**通过站点查询公司 */
    get_simple_organizationFun(id) {
      get_simple_organization({ id: id }).then(res => {
        this.formData2_2.companyId = res.data.id;
        this.formData2_2.company = res.data.name;
      }); //查询站点所属公司
    },
    /*根据公司获取站点*/
    async setstationIdlist(companyId) {
      await getStationByCompanyId({ id: companyId }).then(res => {
        this.sitelist = res.data.map(v => {
          return {
            id: v.stationId,
            name: v.stationName,
          };
        });
      });
    },
    /**预算员设置 */
    // budgetPersonIdFun(e) {
    //   let obj = this.budgetPersonIdList.find((v) => v.userId == e.budgetPersonId)
    //   let json = {
    //     engineeringId: e.engineeringId,//下拉框所在行记录中返回的engineeringId字段值
    //     userId: e.budgetPersonId,//预算员ID
    //     name: obj.userName,//预算员名字
    //     postId: obj.stationId,
    //     phone: obj.stationName
    //   }
    //   updateBudget(json).then((res) => {
    //     if (res.code == 1001) {
    //       this.$message({
    //         message: "设置成功",
    //         type: "success",
    //       });
    //     }
    //   })
    // },
    handlePouringTimeChange() {
      // if(this.surplusJudgeList?.length>0){
      //   var status = this.surplusJudgeList[0].approveStatus
      //   const startTime = new Date(this.surplusJudgeList[0].startTime);
      //   startTime.setHours(0, 0, 0, 0); // 将开始时间设为当天的开始
      //   const endTime = new Date(this.surplusJudgeList[0].endTime);
      //   endTime.setHours(23, 59, 59, 999); // 将结束时间设为当天的结束
      //   const pouringTime = new Date(this.formData.pouringTime);
      //   console.log(this.formData)
      //   console.log(endTime)
      //   console.log(pouringTime)
      //   console.log(startTime)
      //   console.log(pouringTime >= startTime && pouringTime <= endTime)
      //   console.log(status)
      //   if (status === 2 &&(pouringTime >= startTime && pouringTime <= endTime)) {
      //     this.isSurplus = false
      //   }else{
      //     this.isSurplus = true
      //   }
      // }else{
      //   this.isSurplus = true
      // }
    },
    handlePouringTimeChange2() {
      // if(this.surplusJudgeList?.length>0){
      //   var status = this.surplusJudgeList[0].approveStatus
      //   const startTime = new Date(this.surplusJudgeList[0].startTime);
      //   startTime.setHours(0, 0, 0, 0); // 将开始时间设为当天的开始
      //   const endTime = new Date(this.surplusJudgeList[0].endTime);
      //   endTime.setHours(23, 59, 59, 999); // 将结束时间设为当天的结束
      //   const pouringTime = new Date(this.formData2.pouringTime);
      //   console.log(this.formData2)
      //   console.log(endTime)
      //   console.log(pouringTime)
      //   console.log(startTime)
      //   console.log(pouringTime >= startTime && pouringTime <= endTime)
      //   console.log(status)
      //   if (status === 2 &&(pouringTime >= startTime && pouringTime <= endTime)) {
      //     this.isSurplus = false
      //   }else{
      //     this.isSurplus = true
      //   }
      // }else{
      //   this.isSurplus = true
      // }
    },
    async addDialogFun() {
      const res2 = await queryControlMession({ engineeringId: this.engineeringId });
      if (res2.code == 1001) {
        console.log(res2.data.controlStatus);
        if (res2.data.controlStatus == 1) {
          this.$message.warning(`该项目已被管控,${res2.data.controlStatusHint}`);
        } else {
          this.addDialog = true;
          this.formData = this.$options.data().formData;
          console.log(this.surplusJudgeList);
          this.chongZhi();
          this.formData.pouringTime = `${moment().add(1, "days").format("YYYY-MM-DD")} 08:00:00`;
          this.formData.engineeringName = this.engineeringName;
          graphic_list({ engineeringId: this.engineeringId }).then(res => {
            this.structuralPartsList = res.data;
          });

          this.formData.pointId = this.detailData.mainSupplySiteId; // 默认站点ID
          this.formData.pointName = this.detailData.mainSupplySite; // 默认站点名称
          this.formData.servicePoint = this.detailData.servicePoint; // 默认增值服务项
          this.servicePoint = this.detailData.servicePoint
            ? JSON.parse(this.detailData.servicePoint)
                .map(item => item.name)
                .join(",")
            : "";
          this.buspointids = this.detailData.servicePoint ? JSON.parse(this.detailData.servicePoint).map(item => item.id) : "";
          const res = await queryOneResord({
            engineeringId: this.detailData.engineeringId,
          });
          console.log(res.data.paymentMethodId, res.data.paymentMethod);
          this.formData.settleId = res.data.paymentMethodId || "0"; // 默认结算方式
          this.formData.settleName = res.data.paymentMethod || "双控"; // 默认结算方式
          console.log(this.formData.settleId, this.formData.settleName);
          this.$forceUpdate();
        }
      }
    },
    radioAddFun() {
      //作业安排-泵送，运输，泵管；选择后的显示和赋值
      this.chooseType = false;
      if (this.ToViewFun3Name == "选择泵送队") {
        this.formData2_2.pumpingTeam = this.radio.contractNumber + ":" + this.radio.supplierName;
        this.formData2_2.pumpingTeamId = this.radio.supplierId;
      } else if (this.ToViewFun3Name == "选择罐车合同") {
        this.formData2_2.tankCar = this.radio.contractNumber + ":" + this.radio.supplierName;
        this.formData2_2.tankCarId = this.radio.supplierId;
      } else if (this.ToViewFun3Name == "选择泵管单位") {
        this.formData2_2.pipeName = this.radio.contractNumber + ":" + this.radio.supplierName;
        this.formData2_2.pipeId = this.radio.supplierId;
      }
    },
    radioFun(res) {
      //作业安排-泵送，运输，泵管；的单选
      this.radio = res;
      console.log(this.radio);
    },
    async ToViewFun3(name) {
      //作业安排-泵送，运输，泵管；的弹出列表
      this.chooseType = true;
      this.radio = {};
      let id = "";
      if (name == "泵送") {
        this.ToViewFun3Name = "选择泵送队";
        await getContractVoList({
          contractTypeId: 3,
          facilityType: 1,
        }).then(res => {
          this.toViewList2 = res.data;
          id = this.formData2_2.pumpingTeamId;
        });
      } else if (name == "运输") {
        this.ToViewFun3Name = "选择罐车合同";
        await getContractVoList({
          contractTypeId: 2,
        }).then(res => {
          this.toViewList2 = res.data;
          id = this.formData2_2.tankCarId;
        });
      } else if (name == "泵管") {
        this.ToViewFun3Name = "选择泵管单位";
        await getContractVoList({
          contractTypeId: 4,
        }).then(res => {
          this.toViewList2 = res.data;
          id = this.formData2_2.pipeId;
        });
      }
      this.toViewList2.forEach(v => {
        if (v.supplierId == id) {
          console.log(id);
          this.radio = v;
          console.log(JSON.parse(JSON.stringify(this.radio)));
        }
      });
    },
    submit2(approvalStatus) {
      this.buttonType = true;
      //通过和未通过
      this.formData2.approvalStatus = approvalStatus;
      let obj = {
        isAudit: 1,
        arrangement: this.formData2_2,
        engineeringPlan: {
          ...this.formData2,
          lossNum: this.formData2_2.lossNum,
          lossNumId: this.formData2_2.lossNumId,
          approvedTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        planPriceVo: {
          productCosts: this.planProductCost.productCosts,
          pumpCosts: this.planProductCost.pumpCosts,
          superHighs: this.planProductCost.superHighs,
        },
        remark: this.formData2_2.remark, //客户订单备注修改
      };
      check_order(obj)
        .then(res => {
          if (res.code == 1001) {
            this.ProductCostDig = false;
            this.addDialog2 = false;
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.buttonType = false;
            this.ToViewFun();
            this.gettableData();
          }
        })
        .catch(() => {
          this.buttonType = false;
        });
    },
    get_graphic_managerFun() {
      //工程图算查询-浇筑部位列表的查询
      let obj = {
        id: this.engineeringId,
        searchText: this.searchText,
      };
      get_graphic_manager(obj).then(res => {
        this.ListArr = res.data;
      });
    },
    /**点击审核*/
    async ToViewFun2(e, type) {
      const res2 = await queryControlMession({ engineeringId: this.engineeringId });
      if (res2.code == 1001) {
        console.log(res2.data.controlStatus);
        if (res2.data.controlStatus == 1 && type) {
          this.$message.warning(`该项目已被管控,${res2.data.controlStatusHint}`);
        } else {
          this.addDialog2 = true;
          this.isReadOnly = type;
          this.$nextTick(async () => {
            this.$data.formData2 = this.$options.data().formData2;
            this.$refs.reffromData2.clearValidate();
            await this.setstationIdlist(e.companyId);
            this.id = e.id;
            this.remarkList = [];
            this.searchText = e.structuralParts;
            this.get_graphic_managerFun();
            /**历史备注 */
            planRemark({ planId: e.id }).then(res => {
              this.remarkList = res.data;
            });
            plan_detail({ id: this.id }).then(res => {
              //获取订单信息
              this.formData2 = { ...this.formData2, ...res.data };
              console.log(" 获取订单信息 ", this.formData2);
              this.formData2.noteName = this.formData2.productName;
              if (res.data.servicePoint) {
                this.servicePoint = JSON.parse(res.data.servicePoint)
                  .map(item => item.name)
                  .join(",");
                this.formData2.servicePoint = res.data.servicePoint;
              } else {
                this.servicePoint = "";
                this.formData2.servicePoint = "";
              }
              operation_detail({
                //获取作业安排信息
                planId: this.id,
                enginnerId: this.engineeringId,
              }).then(res => {
                this.formData2_2 = { ...this.formData2_2, ...res.data };
                console.log(res.data);
                this.formData2_2.settleId = res.data.settleId;
                if (this.formData2_2.pointId && this.sitelist) {
                  let type = this.sitelist.findIndex(v => v.id == this.formData2_2.pointId);
                  if (type == -1) {
                    this.formData2_2.pointId = "";
                  }
                  // if (res.data.servicePoint) {
                  //   const existDetails = JSON.parse(res.data.servicePoint);
                  //   this.servicePoint = existDetails.map(item => item.name).join(",");
                  //   this.formData2.servicePoint = res.data.servicePoint;
                  //   this.buspointids = existDetails.map(item => item.id);
                  //   // 同时为了保证弹窗打开时有备选项，利用当前站点静默刷新一下备选列表
                  //   if (this.formData2_2.pointId) {
                  //     queryProcesses({ stationId: this.formData2_2.pointId }).then(pRes => {
                  //       if (pRes.code === 1001) {
                  //         const allItems = pRes.data.servicePoint ? JSON.parse(pRes.data.servicePoint) : [];
                  //         this.buspointArr = allItems.map(item => ({ id: item.id, itemName: item.name }));
                  //       }
                  //     });
                  //   }
                  // } else {
                  //   // 订单没有服务项，走新接口自动联动
                  //   this.choiseBussinessPoint(true);
                  // }
                }
                get_assess({ engineeringId: this.engineeringId }).then(res => {
                  if (res.data) {
                    this.assess = res.data;
                  }
                });
                if (this.formData2.performanceGradeId) {
                  this.formData2.performanceGradeIdList = JSON.parse(this.formData2.performanceGradeId).map(v => {
                    return v.id;
                  });
                } else {
                  this.formData2.performanceGradeIdList = [];
                }
                if (this.formData2.meterialRequirementsId) {
                  this.formData2.meterialRequirementsIdList = JSON.parse(this.formData2.meterialRequirementsId).map(v => {
                    return v.id;
                  });
                } else {
                  this.formData2.meterialRequirementsIdList = [];
                }
                if (this.formData2.specialRequirementsId) {
                  this.formData2.specialRequirementsIdList = JSON.parse(this.formData2.specialRequirementsId).map(v => {
                    return v.id;
                  });
                } else {
                  this.formData2.specialRequirementsIdList = [];
                }
                if (this.formData2.otherRequirementsId) {
                  this.formData2.otherRequirementsIdList = JSON.parse(this.formData2.otherRequirementsId).map(v => {
                    return v.id;
                  });
                } else {
                  this.formData2.otherRequirementsIdList = [];
                }
                if (this.formData2.admixtureRequirements) {
                  this.formData2.admixtureRequirementsIdList = JSON.parse(this.formData2.admixtureRequirements).map(v => {
                    return v.id;
                  });
                } else {
                  this.formData2.admixtureRequirementsIdList = [];
                }
                if (this.formData2.pouringMethod) {
                  //   this.formData2.pouringMethodIdList = JSON.parse(this.formData2.pouringMethod).map((v) => {
                  //     return v.id
                  //   });
                  this.formData2.pouringMethodIdList = JSON.parse(this.formData2.pouringMethod).map(v => {
                    return v.name;
                  });
                } else {
                  this.formData2.pouringMethodIdList = [];
                }
                this.formData2_2.lossNumId = res.data.lossNumId || "";
                this.$refs.reffromData2_2.clearValidate();
                console.log(" 2获取订单信息 ", this.formData2);
              });
              // if(this.surplusJudgeList?.length>0){
              //   var status = this.surplusJudgeList[0].approveStatus
              //   const startTime = new Date(this.surplusJudgeList[0].startTime);
              //   startTime.setHours(0, 0, 0, 0); // 将开始时间设为当天的开始
              //   const endTime = new Date(this.surplusJudgeList[0].endTime);
              //   endTime.setHours(23, 59, 59, 999); // 将结束时间设为当天的结束
              //   const pouringTime = new Date(this.formData2.pouringTime);
              //   console.log(this.formData2)
              //   console.log(this.formData2_2)
              //   console.log(endTime)
              //   console.log(pouringTime)
              //   console.log(startTime)
              //   console.log(pouringTime >= startTime && pouringTime <= endTime)
              //   console.log(status)
              //   if (status === 2 && (pouringTime >= startTime && pouringTime <= endTime)) {
              //     this.isSurplus = false
              //   }else{
              //     this.isSurplus = true
              //   }
              // }else{
              //   this.isSurplus = true
              // }
            });
            /**
             * @Description: 获取工程的增值服务项
             * @param {*}
             * @Author: wangwangwang
             */
            if (type) {
              queryOneResord({ engineeringId: this.engineeringId }).then(res => {
                if (res.code === 1001) {
                  const newData = res.data.servicePoint ? JSON.parse(res.data.servicePoint) : [];
                  if (newData.length) {
                    this.servicePoint = newData.map(item => item.name).join(",");
                    this.formData2.servicePoint = res.data.servicePoint;
                    this.buspointids = newData.map(item => item.id);
                  } else {
                    this.servicePoint = "";
                    this.formData2.servicePoint = "";
                    this.buspointids = [];
                  }
                }
              });
            }
          });
        }
      }
    },
    /**
      查看用料计划详情
      当e存在时，从主列表进入，否则是自身搜索或者处理完成返回这个页面。
    **/
    ToViewFun(e) {
      this.ids = [];
      //查看
      this.ToViewType = true;
      if (e) {
        this.setstationIdlist(e.companyId);
        this.tableInfo = {};
        this.query = {};
        this.engineeringRow = e;
        this.engineeringName = e.engineeringName;
        this.formData.engineeringName = e.engineeringName;
        this.surplusJudgeList = [];
        this.surplusJudgeList = e.surplusList;
        this.isSurplus = e.surplusApplay == 1 ? false : true;
        this.engineeringId = e.engineeringId;
        this.tableInfo.engineeringName = e.engineeringName;
        this.tableInfo.customerName = e.customerName;
        this.tableInfo.totalPoureCount = e.totalPoureCount;
        this.tableInfo.engineeringName = e.engineeringName;
        this.tableInfo.phaseId = e.phaseId;
        this.getDisClostDisAddCostFun(e.engineeringId);
        queryExcessAllowance({id:e.engineeringId}).then(res => {
          if(res.code == 1001) {
            this.marginNumberList = res.data
          }
        })
      }
      console.log(this.surplusJudgeList);
      plan_list({
        engineeringId: this.engineeringId,
        ...this.query,
      }).then(res => {
        this.toViewList = res.data;
      });
      plan_table_detail({
        engineeringId: this.engineeringId,
      }).then(res => {
        if (res.data) {
          this.tableInfo.limitEstimateNum = res.data.limitEstimateNum;
          this.tableInfo.limitFinishTime = res.data.limitFinishTime;
        }
      });
    },
    // 富余量申请
    surplusAdd: _debounce(function (e) {
      this.surplusList = e.surplusList;
      if(e.excessAllowance!=null||e.excessAllowance!=undefined||e.excessAllowance!=''){
        this.surplusFormData.excessAllowance = JSON.parse(e.excessAllowance)
      }
      this.surplusFormData.engineeringId = e.engineeringId;
      this.surplusFormData.engineeringName = e.engineeringName;
      this.surplusFormData.approveStatus = 0;
      this.$router.push({
        name: "surplusFlow",
        query: {
          formData: JSON.stringify(this.surplusFormData),
          dataContent: JSON.stringify(this.surplusFormData),
          type: 1,
        },
      });
      //取消添加时间
      // this.surplusDialog = true;
    }, 500),
    cancelSurplus() {
      this.surplusDateDialog = false;
      this.surplusFormData = [];
    },
    saveSurplus: _debounce(function () {
      console.log(this.surplusFormData);
      let formData = this.surplusFormData;
      if (this.surplusFormData.startTime == "" || this.surplusFormData.endTime == "") {
        this.$message.warning("起始日期必选！");
        return;
      }
      saveSurplus(this.surplusFormData).then(res => {
        if (res.code == 1001) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
        }
        formData.id = res.data;
        this.$router.push({
          name: "surplusFlow",
          query: {
            formData: JSON.stringify(formData),
            dataContent: JSON.stringify(formData),
            type: 1,
          },
        });
        console.log(formData);
      });
      this.cancelSurplus();
    }, 500),
    /**
     * @Description: 调整工程负责人
     * @param {*} data
     * @Author: wangwangwang
     */
    handleEdit(data) {
      get_simple_user_listBycompanyId({
        roleId: "12b2f6ff304148fd89141e9faa9afb96",
        orgznizationId: data.companyId,
      }).then(res => {
        this.sallerIdList = res.data;
      });
      get_simple_user_listBycompanyId({
        roleId: "48d84b503be7484ca1b5c2eade1ff004",
        orgznizationId: data.companyId,
      }).then(res => {
        this.budgetPersonIdList2 = res.data;
      });
      this.engineeringId = data.engineeringId;
      queryOneResord({ engineeringId: data.engineeringId }).then(res => {
        if (res.code === 1001) {
          this.personEdit = true;
          this.personForm = {
            budgetPersonId: res.data.budgetPersonId,
            budgetPerson: res.data.budgetPerson,
            buseftPlaceTypeId: res.data.buseftPlaceTypeId,
            buseftPlaceType: res.data.buseftPlaceType,
            sallerId: res.data.sallerId,
            saller: res.data.saller,
            placeTypeId: res.data.placeTypeId,
            placeType: res.data.placeType,
          };
        }
      });
    },
    init() {
      /*重置数据*/
      this.tableParam.contractNo = "";
      this.tableParam.surplusApplay = "";
      this.tableParam.engineeringName = "";
      let id = this.budgetPersonIdList.findIndex(v => v.userId == this.UserInfo.userId);
      if (id != -1) {
        this.tableParam.budgetPersonId = this.budgetPersonIdList[id].userId;
      }
      this.gettableData();
    },
    //添加计划
    submit() {
      const params = {
        remark: this.formData.remark,
        arrangement: {
          pointId: this.formData.pointId,
          pointName: this.formData.pointName,
          settleId: this.formData.settleId,
          settleName: this.formData.settleName,
          lossNumId: this.formData.lossNumId,
          lossNum: this.formData.lossNum,
          enginnerId: this.formData.enginnerId,
          remark: this.formData.remark,
          servicePoint: this.formData.servicePoint,
          graphicNum: this.formData.graphicNum,
        },
        engineeringPlan: { ...this.formData },
        planPriceVo: {
          productCosts: this.planProductCost.productCosts,
          pumpCosts: this.planProductCost.pumpCosts,
          superHighs: this.planProductCost.superHighs,
        },
      };

      savePlan(params).then(res => {
        if (res.code == 1001) {
          this.addDialog = false;
          this.ProductCostDig = false;
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.ToViewFun();
          this.gettableData();
        }
      });
      plan_list({
        engineeringId: this.engineeringId,
        ...this.query,
      }).then(res => {
        this.toViewList = res.data;
      });
    },
    chongZhi() {
      this.$data.formData = this.$options.data().formData;
      setTimeout(() => {
        this.$refs.reffromData.clearValidate();
      }, 100);
    },
    slumpChange() {
      if (this.formData.slump && this.slumpArr.length > 0) {
        let slumpItem = this.slumpArr.filter(item => {
          return item.itemName == this.formData.slump;
        });
        this.formData.slumpId = slumpItem[0].id;
      }
      console.log(" slump ", this.formData.slump);
      console.log(" slumpId ", this.formData.slumpId);
    },
    structuralPartsCheckFun() {
      this.formData.strengthGradeId = "";
      this.formData.performanceGradeIdList = "";
      this.formData.meterialRequirementsIdList = "";
      this.formData.specialRequirementsIdList = "";
      this.formData.otherRequirementsIdList = "";
      this.formData.admixtureRequirementsIdList = "";
      let item = this.structuralPartsList.find(v => v.id == this.formData.structuralParts);
      if (item) {
        this.formData.strengthGradeId = JSON.parse(item.strengthGrade)[0].id;
        if (item.performanceGrade) {
          this.formData.performanceGradeIdList = JSON.parse(item.performanceGrade).map(v => v.id);
        }
        if (item.meterialRequirements) {
          this.formData.meterialRequirementsIdList = JSON.parse(item.meterialRequirements).map(v => v.id);
        }
        if (item.specialRequirements) {
          this.formData.specialRequirementsIdList = JSON.parse(item.specialRequirements).map(v => v.id);
        }
        if (item.otherRequirements) {
          this.formData.otherRequirementsIdList = JSON.parse(item.otherRequirements).map(v => v.id);
        }
        if (item.admixtureRequirements) {
          this.formData.admixtureRequirementsIdList = JSON.parse(item.admixtureRequirements).map(v => v.id);
        }
      }
    },
    structuralPartsFun() {
      console.log(this.structuralPartsList, this.formData.structuralParts);
      let item = this.structuralPartsList.find(v => v.id == this.formData.structuralParts);
      if (item) {
        this.formData.structuralPartsId = this.formData.structuralParts;
        this.formData.structuralParts = item.structuralParts;
      } else {
        this.formData.structuralPartsId = "";
      }
    },
    /**查询该工程的强度等级+各项要求+浇筑部位 */
    getDisClostDisAddCostFun(id) {
      getDisClostDetail({ id }).then(res => {
        if (res.code === 1001) {
          this.strengthGradeList = JSON.parse(res.data.strengthGrade);
          this.performanceGradeList = JSON.parse(res.data.performanceRate);
          //材料要求pouringMethodList
          this.meterialRequirementsList = JSON.parse(res.data.materialRequirements);
          //特殊要求
          this.specialRequirementsList = JSON.parse(res.data.specialRequirements);
          //外加剂要求
          this.admixtureRequirementsList = JSON.parse(res.data.admixtureRequirements);
          //其他要求
          this.otherRequirementsList = JSON.parse(res.data.otherRequirements);
          //浇筑方式
          this.pouringMethodList = JSON.parse(res.data.pumpType);

          this.detailData = res.data;
        }
      });
    },
    selectableFun(row) {
      if (row.approvalStatus !== 4) {
        return true;
      }
    },
    /**富余量：判断选项是否是数字 */
    numberType(e) {
      let reg = new RegExp(/^\d+$|^\d*\.\d+$/);
      if (reg.test(e)) {
        return false;
      } else {
        return true;
      }
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
  filters: {
    pouringMethodFilter(e) {
      let table = e.map(res => res.name);
      let text = table.join("、");
      return text;
    },
  },
};
